import { render, staticRenderFns } from "./TelcellPayments.vue?vue&type=template&id=72a8a88f"
import script from "./TelcellPayments.vue?vue&type=script&lang=js"
export * from "./TelcellPayments.vue?vue&type=script&lang=js"
import style0 from "./TelcellPayments.vue?vue&type=style&index=0&id=72a8a88f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports